import React from 'react'
import PropTypes from 'prop-types'

const Card = ({
  title,
  className = '',
  children
}) => {
  return <div className={`Card u-pA6 ${className}`}>
    <h4 className='u-mB2'>{title}</h4>
    {children}
  </div>
}

Card.propTypes = {
  /** A card can have a title displayed as a header */
  title: PropTypes.string,
  /** A card can apply additional CSS classes */
  className: PropTypes.string,
  /** The card's primary content */
  children: PropTypes.node
}

export default Card